import {Pagination} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/pagination.types';
import {ProductImageTypes} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';
import {SortOptions} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sort_options.types';
import {mobileOnlyLinaria} from '@aboutyou/ui-components';
import {PRODUCTS_PER_PAGE} from './constants';

export const labelToSortingOption = (label?: string | null) => {
  switch (label) {
    case 'new':
      return SortOptions.MOST_RECENT;
    case 'price_high':
      return SortOptions.HIGHEST_PRICE;
    case 'price_low':
      return SortOptions.LOWEST_PRICE;
    case 'highest_reduction':
      return SortOptions.HIGHEST_REDUCTION;
    default:
      return SortOptions.UNSPECIFIED;
  }
};

export const labelToProductImageType = (
  label?: string | null,
): ProductImageTypes | undefined => {
  switch (label) {
    case 'model':
      return ProductImageTypes.MODEL;
    case 'product':
      return ProductImageTypes.BUST;
    default:
      return undefined;
  }
};

export const getPagination = (page: number): Pagination => ({
  offset: (page - 1) * PRODUCTS_PER_PAGE,
  limit: PRODUCTS_PER_PAGE,
});

const STREAM_PRODUCT_TILE_SIDE_PADDING = 16;

/* None product tile placements should be 32px between from the product tiles
 * padding top is 8px, because the grid of the stream has 5px, plus other 19px
 * on the padding bottom of the product details, which is 8 + 5 + 19 = 32
 *
 * Same with the padding bottom, it's 27px, plus the 5px of the grid 27 + 5 = 32
 *
 * There something will be 2 non product tiles placements on top of each other,
 * we cannot know when this happen, so we'll have 3 extra pixels
 *
 * Margin inline (X axis) -16 is to overcome the 16px padding for the product tiles,
 * so this placements occupy 100% width of the viewport
 * **/
export const NonProductTileSpacingAdjustment = mobileOnlyLinaria(`
  padding-bottom: 27px;
  padding-top: 8px;
`);

export const StreamPaddingCSS = mobileOnlyLinaria(`
  --stream-padding: ${STREAM_PRODUCT_TILE_SIDE_PADDING}px;
  padding-inline: var(--stream-padding);
`);
